import V3Check from './V3Check'
import { CheckUtils } from 'utils'

export default class V3BlogOnOwnDomainCheck extends React.Component {
  constructor(props) {
    super(props)

    this.renderInfo = this.renderInfo.bind(this)
    this.renderDetails = this.renderDetails.bind(this)
  }

  render() {
    const props = {
      ...this.props,
      info: this.renderInfo,
      details: this.renderDetails
    }

    return <V3Check { ...props } />
  }

  renderDetails() {
    return CheckUtils.renderDetailsList(this.props.check.checkItems)
  }

  renderInfo() {
    return (
      <div>
        <h2>Key points</h2>
        <p>
          Hosting your blog on your own domain means that you will build SEO value into your own website rather than someone else's.
        </p>
        <hr />
        <h2>How it's used</h2>
        <ul>
          <li>Search engines treat folders like yourcompany.com/blog as being part of the same site</li>
          <li>SEO trust and relevancy is shared throughout the site</li>
          <li>Subdomains like blog.yourcompany.com as treated similarly</li>
          <li>If blogging-platform.com has a bad reputation then some of this will affect yourblog.blogging-platform.com</li>
        </ul>
        <hr />
        <h2>Best practice</h2>
        <ul>
          <li>Use a folder or subdomain off of your main website like yourcompany.com/blog or blog.yourcompany.com</li>
          <li>You can use a platform like Wordpress.com, but make sure to select their custom domain option to use blog.yourcompany.com</li>
          <li>Avoid subdomains and folders off of sites you don't control like yourblog.blogspot.com</li>
        </ul>
        <hr />

        <h2>Fix this yourself</h2>
        <h3>Use the Shopify blogging feature</h3>
        The simplest solution is to use Shopify's built-in blogging feature. It supports the key features like post scheduling and full control over post look and feel.
        <h3>Or if you must use a different blogging platform, point a subdomain there</h3>
        If you prefer a separate blog like Wordpress or Tumblr, make sure that its URL is a subdomain of your main Shopify store.
        <p>
          So if your shop is available at example.com, create a new subdomain blog.example.com and associate this with your blog.
        </p>
        <p>
          How you do this depends on the company you've registered your domain name through and the blogging platform you use. Contact their support to talk about how to set it up.
        </p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/v3_checks/V3BlogOnOwnDomainCheck.js